/******************************************************************************
 *** MbrasLeaveApply ** 휴직 신청서
 *******************************************************************************/
import AppContext from "@/js/common/AppContext";
import Axios from "@/js/common/Axios";
import Button from "@/js/common/ui/Button";
import DatePickerBox from "@/js/common/ui/input/DatePickerBox";
import SelectBox from "@/js/common/ui/input/SelectBox";
import TextBox from "@/js/common/ui/input/TextBox";
import Util from "@/js/common/Util";
import React from "react";

import MemberFile from "../FileBox/MemberFile";
import RadioBox from "@/js/common/ui/input/RadioBox";
import AtrzLineBox from "../../bgtovrl/dialog/AtrzLineBox";

const MbrasLeaveApply = (props: any) => {
    const {
        mbrasId,
        mbrasAtrzDocId,
        selectedMember,
        setModalOpen,
        setModalStep,
        setCallTime,
    } = props;

    const [mbrasNm          , setMbrasNm          ] = React.useState(""); // 성명
    const [telno            , setTelno            ] = React.useState(""); // 전화번호
    const [brdtDate         , setBrdtDate         ] = React.useState(""); // 생년월일
    const [gndrCd           , setGndrCd           ] = React.useState(""); // 성별
    const [frstJncmpYmd      , setFrstJncmpYmd      ] = React.useState(""); // 입직년월일(최초입사일자)
    const [lbrShpSeCd       , setLbrShpSeCd       ] = React.useState(""); // 근로형태
    const [ocptTypeCd       , setOcptTypeCd       ] = React.useState(""); // 직종
    const [ogdpOrgCd        , setOgdpOrgCd        ] = React.useState(""); // 소속조직
    const [wtjrNm           , setWtjrNm           ] = React.useState(""); // 관내
    const [addr             , setAddr             ] = React.useState(""); // 주소

    const [mbrasJoinSttsCd  , setMbrasJoinSttsCd  ] = React.useState(""); // 현재 조합원 상태
    const [wthdStatusCd     , setWthdStatusCd     ] = React.useState(""); // 현재 원천징수 상태

    const [chgMbrasJoinSttsCd, setChgMbrasJoinSttsCd] = React.useState("02"); // 변경 조합원 상태
    const [leaveTypeCd      , setLeaveTypeCd      ] = React.useState("");     // 휴직분류
    const [leaveEtcRsnCn    , setLeaveEtcRsnCn    ] = React.useState("");     // 기타사유
    const [chgWthdStatusCd  , setChgWthdStatusCd  ] = React.useState("");     // 변경 원천징수 상태

    const [applyDt          , setApplyDt          ] = React.useState(""); // 신청일자
    const [leaveStartDt     , setLeaveStartDt     ] = React.useState(""); // 휴직 시작일자
    const [leaveEndDt       , setLeaveEndDt       ] = React.useState(""); // 휴직 종료일자

    const [atrzSttsCd       , setAtrzSttsCd       ] = React.useState("01"); // 결재상태
    const [atrzOpnnCn       , setAtrzOpnnCn       ] = React.useState("");   // 반려사유
    const [listLine         , setListLine         ] = React.useState<any[]>([]); // 결재 라인 정보
    const [openLine         , setOpenLine         ] = React.useState<boolean>(false); // 기본 펼침/접힘

    const [wthdFile         , setWthdFile         ] = React.useState<File>(); // 원천징수 동의서
    const [wthdFileNm       , setWthdFileNm       ] = React.useState("");     // 원천징수 동의서명
    const [wthdAtchFileId   , setWthdAtchFileId   ] = React.useState("");     // 원천징수 첨부파일 ID

    const [etcFile          , setEtcFile          ] = React.useState<File>(); // 기타 첨부파일
    const [etcFileNm        , setEtcFileNm        ] = React.useState("");     // 기타 첨부파일명
    const [etcAtchFileId    , setEtcAtchFileId    ] = React.useState("");     // 기타 첨부파일 ID

    // 현재 조합원 정보
    React.useEffect(() => {
        if (!selectedMember) return;

        setMbrasNm         (String(selectedMember.mbrasNm));          // 성명
        setTelno           (String(selectedMember.telno));            // 전화번호
        setBrdtDate        (String(selectedMember.brdtDate));         // 생년월일
        setGndrCd          (String(selectedMember.gndrCd));           // 성별
        setFrstJncmpYmd    (String(selectedMember.frstJncmpYmd));     // 입직년월일(최초입사일자)
        setLbrShpSeCd      (String(selectedMember.lbrShpSeCd));       // 근로형태
        setOcptTypeCd      (String(selectedMember.ocptTypeCd));       // 직종
        setOgdpOrgCd       (String(selectedMember.ogdpOrgCd));        // 소속조직
        setWtjrNm          (String(selectedMember.wtjrNm));           // 관내
        setAddr            (String(selectedMember.addr));             // 주소
        setMbrasJoinSttsCd (String(selectedMember.mbrasJoinSttsCd));  // 현재 조합원 상태
        setWthdStatusCd    (String(selectedMember.wthdStatusCd));       // 현재 원천징수 상태
    }, [selectedMember]);

    // 기존 변경 신청 문서 상세정보
    React.useEffect(() => {
        if (Util.isEmpty(mbrasAtrzDocId)) return;

        AppContext.showSpinner();

        Axios.dataAccess({
            url       : "system/mbras/chg/select-mbras-atrz-chg-detail.do",
            methodType: "post",
            paramType : "json",
            paramData : {
                mbrasAtrzDocId: mbrasAtrzDocId,                       // 조합원 결재 문서 ID
            },
            onSuccessFn: (res: any) => {
                const mbrasDoc = res.result.mbrasDoc;                  // 변경 결재 문서정보
                const listItem = res.result.listItem;                  // 변경 신청 항목
                const listFile = res.result.listFile;                  // 첨부파일 목록
                const atrzLine = res.result.listLine;                  // 결재라인

                const joinSttsItem   = listItem.find((item: any) => item.mbrasInfoChgSeCd === "07"); // 조합원 상태
                const wthdStatusItem = listItem.find((item: any) => item.mbrasInfoChgSeCd === "08"); // 원천징수 상태
                const leaveDateItem  = listItem.find((item: any) => item.mbrasInfoChgSeCd === "09"); // 휴직기간
                const leaveTypeItem  = listItem.find((item: any) => item.mbrasInfoChgSeCd === "10"); // 휴직분류

                if (joinSttsItem)   setChgMbrasJoinSttsCd(String(joinSttsItem.chgAfterCn)); // 변경 조합원 상태
                if (wthdStatusItem) setChgWthdStatusCd   (String(wthdStatusItem.chgAfterCn)); // 변경 원천징수 상태
                if (leaveDateItem)  setLeaveStartDt      (String(leaveDateItem.chgBefCn));    // 휴직 시작일자
                if (leaveDateItem)  setLeaveEndDt        (String(leaveDateItem.chgAfterCn));  // 휴직 종료일자
                if (leaveTypeItem)  setLeaveTypeCd       (String(leaveTypeItem.chgBefCn));    // 휴직분류
                if (leaveTypeItem)  setLeaveEtcRsnCn     (String(leaveTypeItem.chgAfterCn));  // 기타 휴직사유

                setApplyDt      (String(mbrasDoc.applyDt));     // 신청일자
                setAtrzSttsCd   (String(mbrasDoc.atrzSttsCd));  // 결재상태
                setAtrzOpnnCn   (String(mbrasDoc.atrzOpnnCn));  // 반려사유
                setListLine     (atrzLine);                     // 결재라인

                const wthdFileInfo = listFile.find((item: any) => item.mbrasFileSeCd === "02"); // 원천징수 첨부파일
                const etcFileInfo  = listFile.find((item: any) => item.mbrasFileSeCd === "03"); // 기타 첨부파일

                if (wthdFileInfo) {
                    setWthdAtchFileId(String(wthdFileInfo.mbrasAtchFileId)); // 원천징수 첨부파일 ID
                    setWthdFileNm    (String(wthdFileInfo.fileNm));          // 원천징수 첨부파일명
                }

                if (etcFileInfo) {
                    setEtcAtchFileId(String(etcFileInfo.mbrasAtchFileId));   // 기타 첨부파일 ID
                    setEtcFileNm    (String(etcFileInfo.fileNm));            // 기타 첨부파일명
                }

                AppContext.hideSpinner();
            },
        });
    }, [mbrasAtrzDocId]);

    const getParamData = (saveAtrzSttsCd: string) => {
        return {
            mbrasAtrzDocId : mbrasAtrzDocId,  // 조합원 결재 문서 ID
            mbrasAtrzSeCd  : "06",             // 휴직
            mbrasId        : mbrasId,          // 조합원 ID

            mbrasNm        : mbrasNm,          // 성명
            telno          : telno,            // 전화번호
            brdtDate       : brdtDate,         // 생년월일
            gndrCd         : gndrCd,           // 성별
            frstJncmpYmd   : frstJncmpYmd,     // 입직년월일(최초입사일자)
            lbrShpSeCd     : lbrShpSeCd,       // 근로형태
            ocptTypeCd     : ocptTypeCd,       // 직종
            ogdpOrgCd      : ogdpOrgCd,        // 소속조직
            wtjrNm         : wtjrNm,           // 관내
            addr           : addr,             // 주소

            mbrasJoinSttsCd: mbrasJoinSttsCd,  // 현재 조합원 상태
            wthdStatusCd   : wthdStatusCd,     // 현재 원천징수 상태

            chgMbrasJoinSttsCd: chgMbrasJoinSttsCd, // 변경 조합원 상태
            leaveTypeCd    : leaveTypeCd,           // 휴직분류
            leaveEtcRsnCn  : leaveEtcRsnCn,         // 기타사유
            chgWthdStatusCd: chgWthdStatusCd,       // 변경 원천징수 상태

            applyDt        : applyDt,          // 신청일자
            leaveStartDt   : leaveStartDt,     // 휴직 시작일자
            leaveEndDt     : leaveEndDt,       // 휴직 종료일자

            atrzSttsCd     : saveAtrzSttsCd,   // 01: 임시저장, 02: 작성완료
            wthdFile       : wthdFile,         // 원천징수 상태 변경 서류
            etcFile        : etcFile,          // 기타 첨부파일
            callType       : "MEMBER",         // 첨부파일 저장경로
        };
    };

    const handleSave = (saveAtrzSttsCd: string) => {
        if (saveAtrzSttsCd === "02" && Util.isEmpty(applyDt)) { AppContext.openAlert({ title: "신청일자 확인", msg: "신청일자를 입력해주세요.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && Util.isEmpty(leaveStartDt)) { AppContext.openAlert({ title: "휴직 시작일자 확인", msg: "휴직 시작일자를 입력해주세요.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && Util.isEmpty(leaveEndDt)) { AppContext.openAlert({ title: "휴직 종료일자 확인", msg: "휴직 종료일자를 입력해주세요.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && Util.isNotEmpty(leaveStartDt) && Util.isNotEmpty(leaveEndDt) && leaveStartDt > leaveEndDt) { AppContext.openAlert({ title: "휴직기간 확인", msg: "휴직 종료일자는 시작일자 이후로 입력해주세요.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && Util.isEmpty(leaveTypeCd)) { AppContext.openAlert({ title: "휴직분류 확인", msg: "휴직분류를 선택해주세요.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && Util.isEmpty(chgWthdStatusCd)) { AppContext.openAlert({ title: "원천징수 확인", msg: "원천징수 상태를 선택해주세요.", icon: "warning" }); return; }
        if (saveAtrzSttsCd === "02" && Util.isNotEmpty(chgWthdStatusCd) && wthdStatusCd !== chgWthdStatusCd && !wthdFile && Util.isEmpty(wthdAtchFileId)) { AppContext.openAlert({ title: "첨부파일 확인", msg: "원천징수 상태 변경 관련 서류를 첨부해주세요.", icon: "warning" }); return; }

        const saveTitle = saveAtrzSttsCd === "01" ? "임시저장" : "작성완료";
        const saveMsg = saveAtrzSttsCd === "01" ? "임시 저장하시겠습니까?" : "작성완료 처리하시겠습니까?";

        AppContext.openAlert({
            title      : saveTitle,
            msg        : saveMsg,
            confirmText: saveTitle,
            handleConfirm: () => {
                const paramData = getParamData(saveAtrzSttsCd);

                AppContext.showSpinner();

                Axios.dataAccess({
                    url        : "system/mbras/chg/save-mbras-atrz-chg.do",
                    methodType : "post",
                    isMultipart: true,
                    paramData  : paramData,
                    onSuccessFn: () => {
                        setAtrzSttsCd(saveAtrzSttsCd);

                        AppContext.hideSpinner();

                        AppContext.openAlert({
                            title: "저장 완료",
                            msg  : saveAtrzSttsCd === "01" ? "임시저장 처리되었습니다." : "작성완료 처리되었습니다.",
                            icon : "success",
                        });

                        setCallTime(Date.now());
                        setModalOpen(false);
                    },
                });
            },
        });
    };

    const handleDelete = () => {
        if (Util.isEmpty(mbrasAtrzDocId)) return;

        AppContext.openAlert({
            title      : "삭제",
            msg        : "정말 삭제하시겠습니까?",
            confirmText: "삭제하기",
            handleConfirm: () => {
                AppContext.showSpinner();

                Axios.dataAccess({
                    url       : "system/mbras/chg/delete-mbras-atrz-chg.do",
                    methodType: "post",
                    paramType : "json",
                    paramData : {
                        mbrasAtrzDocId: mbrasAtrzDocId,
                    },
                    onSuccessFn: () => {
                        AppContext.hideSpinner();

                        AppContext.openAlert({
                            title: "삭제 완료",
                            msg  : "삭제가 완료되었습니다.",
                            icon : "success",
                        });

                        setCallTime(Date.now());
                        setModalOpen(false);
                    },
                });
            },
        });
    };

    return (
        <div className="w100p dpFlx">
            <div className="w540">
                {atrzSttsCd === "05" && (
                    <div className="ml10 mr10">
                        <AtrzLineBox
                            listLine={listLine}
                            open={openLine}
                            onToggle={() => setOpenLine((v) => !v)}
                            showOrgInfo={true}
                        />
                    </div>
                )}

                {/* 조합원 정보 */}
                <div className="m10">
                    <div className="fm-b fs16 fc007bff ls1 fw700 mb10">조합원 정보</div>

                    <div className="p14 bd1 bdcDDDDDD bdrd10 bgcFAFAFA bsBdb">
                        <div className="dpFlx flxNowrap jcSb">
                            <div className="w240 dpFlx aiC">
                                <span className="w60 fm-b fs13 ls06 fc111111">성명</span>
                                <TextBox
                                    value={mbrasNm}
                                    width={180}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#ddd"
                                    borderRadius={5}
                                    style={{ backgroundColor: "#F6F6F6", padding: "0 10px" }}
                                    mode="readonly"
                                />
                            </div>

                            <div className="w240 dpFlx aiC">
                                <span className="w60 fm-b fs13 ls06 fc111111">전화번호</span>
                                <TextBox
                                    value={Util.setPhoneNum(telno)}
                                    width={180}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#ddd"
                                    borderRadius={5}
                                    style={{ backgroundColor: "#F6F6F6", padding: "0 10px" }}
                                    mode="readonly"
                                />
                            </div>
                        </div>

                        <div className="dpFlx flxNowrap jcSb mt10">
                            <div className="w240 dpFlx aiC">
                                <span className="w60 fm-b fs13 ls06 fc111111">생년월일</span>
                                <DatePickerBox
                                    width={180}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#ddd"
                                    borderRadius={5}
                                    bgColor="#F6F6F6"
                                    textAlign="left"
                                    calendarThemeColor={AppContext.themeColor}
                                    value={brdtDate}
                                    disabled={true}
                                    onChange={() => {}}
                                />
                            </div>

                            <div className="w240 dpFlx aiC">
                                <span className="w60 fm-b fs13 ls06 fc111111">성별</span>
                                <SelectBox
                                    value={gndrCd}
                                    width={180}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#ddd"
                                    borderRadius={5}
                                    background="#F6F6F6"
                                    codeArray={Util.getCodeArray("GNDR_CD")}
                                    placeholder=""
                                    paddingRight={8}
                                    disabled={true}
                                />
                            </div>
                        </div>

                        <div className="dpFlx mt10">
                            <div className="w240 dpFlx aiC">
                                <span className="w60 fm-b fs13 ls06 fc111111">
                                    신청일자 <span className="fcE60000">*</span>
                                </span>
                                <DatePickerBox
                                    width={180}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#222"
                                    borderRadius={5}
                                    bgColor="white"
                                    textAlign="left"
                                    calendarThemeColor={AppContext.themeColor}
                                    value={applyDt}
                                    onChange={(data: string) => setApplyDt(data)}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* 휴직 내역 */}
                <div className="ml10 mr10 mt20">
                    <div className="fm-b fs16 fc007bff ls1 fw700 mb10">휴직 내역</div>

                    <div className="bd1 bdcDDDDDD bdrd10">
                        <div className="dpFlx bdb1 bdcDDDDDD">
                            <div className="w100 h40 dpFlx aiC jcC fm-b fs13 fc111111 bgcFAFAFA bdrdtl10">구분</div>
                            <div className="w210 h40 dpFlx aiC jcC fm-b fs13 fc111111 bdl1 bdcDDDDDD bgcFAFAFA">현재</div>
                            <div className="w210 h40 dpFlx aiC jcC fm-b fs13 fc111111 bdl1 bdcDDDDDD bgcF1F8FF bdrdtr10">변경</div>
                        </div>

                        {/* 신청기간 */}
                        <div className="posR dpFlx bdb1 bdcDDDDDD">
                            <div className="w100 h40 dpFlx aiC jcC fm-c fs14 fc333333">휴직기간</div>

                            <div className="w210 h40 dpFlx aiC jcC bdl1 bdcDDDDDD bgcF1F8FF">
                                <DatePickerBox
                                    width={170}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#222"
                                    borderRadius={5}
                                    bgColor="white"
                                    textAlign="left"
                                    calendarThemeColor={AppContext.themeColor}
                                    value={leaveStartDt}
                                    onChange={(data: string) => setLeaveStartDt(data)}
                                />
                            </div>

                            <div className="w210 h40 dpFlx aiC jcC bdl1 bdcDDDDDD bgcF1F8FF">
                                <DatePickerBox
                                    width={170}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#222"
                                    borderRadius={5}
                                    bgColor="white"
                                    textAlign="left"
                                    calendarThemeColor={AppContext.themeColor}
                                    value={leaveEndDt}
                                    onChange={(data: string) => setLeaveEndDt(data)}
                                />
                            </div>

                            {/* ~ 표시 */}
                            <div
                                className="posA h40 dpFlx aiC jcC bgcF1F8FF"
                                style={{
                                    left: "310px",
                                    width: "20px",
                                    transform: "translateX(-50%)",
                                    zIndex: 10,
                                }}
                            >
                                <span className="fm-c fs14 fc333333">~</span>
                            </div>
                        </div>

                        {/* 상태 */}
                        <div className="dpFlx bdb1 bdcDDDDDD">
                            <div className="w100 h40 dpFlx aiC jcC fm-c fs14 fc333333">상태</div>

                            <div className="w210 h40 dpFlx aiC bdl1 bdcDDDDDD">
                                <div className="pl15 fm-c fs14 fc333333">
                                    {Util.getValToCode("MBRAS_JOIN_STTS_CD", mbrasJoinSttsCd)}
                                </div>
                            </div>

                            <div className="w210 h40 dpFlx aiC jcC bdl1 bdcDDDDDD bgcF1F8FF">
                                <SelectBox
                                    value={chgMbrasJoinSttsCd}
                                    width={170}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#ddd"
                                    borderRadius={5}
                                    background="#F6F6F6"
                                    codeArray={Util.getCodeArray("MBRAS_JOIN_STTS_CD")}
                                    placeholder=""
                                    paddingRight={8}
                                    disabled={true}
                                />
                            </div>
                        </div>

                        {/* 휴직분류 */}
                        <div className="dpFlx bdb1 bdcDDDDDD">
                            <div className="w100 h40 dpFlx aiC jcC fm-c fs14 fc333333">휴직분류</div>

                            <div className="w210 h40 dpFlx aiC jcC bdl1 bdcDDDDDD bgcF1F8FF">
                                <SelectBox
                                    value={leaveTypeCd}
                                    width={170}
                                    height={36}
                                    fontSize={14}
                                    fontFamily="fm-c"
                                    color="#333"
                                    letterSpacing={-1}
                                    borderColor="#ddd"
                                    borderOnColor="#222"
                                    borderRadius={5}
                                    background="#fff"
                                    codeArray={Util.getCodeArray("LEAVE_TYPE_CD")}
                                    placeholder="휴직분류 선택"
                                    paddingRight={8}
                                    onChangeFunc={(data: string) => {
                                        setLeaveTypeCd(data);
                                        if (data !== "L07") setLeaveEtcRsnCn("");
                                    }}
                                />
                            </div>

                            <div className="w210 h40 dpFlx aiC jcC bgcF1F8FF">
                                {leaveTypeCd === "L07" && (
                                    <TextBox
                                        value={leaveEtcRsnCn}
                                        width={170}
                                        height={36}
                                        fontSize={14}
                                        fontFamily="fm-c"
                                        color="#333"
                                        letterSpacing={-1}
                                        borderColor="#ddd"
                                        borderOnColor="#222"
                                        borderRadius={5}
                                        style={{ backgroundColor: "#fff", padding: "0 10px" }}
                                        placeholder="기타내용 입력"
                                        onChangeFunc={(text: string) => setLeaveEtcRsnCn(text)}
                                    />
                                )}
                            </div>
                        </div>

                        {/* 원천징수 */}
                        <div className="dpFlx">
                            <div className="w100 h40 dpFlx aiC jcC fm-c fs14 fc333333">원천징수</div>

                            <div className="w210 h40 dpFlx aiC jcC bdl1 bdcDDDDDD">
                                <RadioBox
                                    codeList={Util.getCodeArray("WTHD_STATUS_CD").map((item: any) => ({
                                        code: item.code,
                                        name: item.code === "W01" ? "동의" : "철회",
                                    }))}
                                    value={wthdStatusCd}
                                    btnColor="#007bff"
                                    btnSize={14}
                                    btnClass=""
                                    labelClass="ml5 fm-c fs13 fc333333"
                                    interval={20}
                                    disabled={true}
                                />
                            </div>

                            <div className="w210 h40 dpFlx aiC jcC bdl1 bdcDDDDDD bgcF1F8FF bdrdbr10">
                                <RadioBox
                                    codeList={Util.getCodeArray("WTHD_STATUS_CD").map((item: any) => ({
                                        code: item.code,
                                        name: item.code === "W01" ? "동의" : "철회",
                                    }))}
                                    value={chgWthdStatusCd}
                                    setValue={setChgWthdStatusCd}
                                    btnColor="#007bff"
                                    btnSize={14}
                                    btnClass=""
                                    labelClass="ml5 fm-c fs13 fc333333"
                                    interval={20}
                                />
                            </div>
                        </div>
                    </div>
                </div>

                {/* 반려 사유 */}
                {atrzSttsCd === "05" && (
                    <div className="ml10 mr10">
                        <div className="h30 dpFlx aiE pb5 bdBox">
                            <span className="fm-b fs13 ls06 fc111111">반려 사유</span>
                        </div>
                        <textarea
                            value={atrzOpnnCn}
                            className="w520 h60 bsBdb p10 bd1 bdcDDDDDD bdrd4 fm-c fs14 fc333333 ls1 rszN"
                            style={{ backgroundColor: "#f6f6f6" }}
                            maxLength={2000}
                            disabled={true}
                        />
                    </div>
                )}

                {/* 첨부파일 */}
                <div className="mt20 p14 bd1 bdcDDDDDD bdrd10 w520 bgcFAFAFA bsBdb ml10">
                    <div className="fm-c fs16 fc111111 mb10">첨부파일</div>

                    {Util.isNotEmpty(chgWthdStatusCd) && wthdStatusCd !== chgWthdStatusCd && (
                        <div className="mb12">
                            <div className="h30 dpFlx aiE pb5 bdBox">
                                <span className="fm-b fs13 ls06 fc111111">원천징수 동의서</span>
                                <span className="fm-c fs11 fcE60000 ml4">(필수)</span>
                            </div>

                            <div className="mt6">
                                <MemberFile
                                    mbrasId={mbrasId}
                                    mbrasAtchFileId={wthdAtchFileId}
                                    setMbrasAtchFileId={setWthdAtchFileId}
                                    mbrFile={wthdFile}
                                    setMbrFile={setWthdFile}
                                    mbrFileNm={wthdFileNm}
                                    setMbrFileNm={setWthdFileNm}
                                    atrzSttsCd={atrzSttsCd}
                                    mbrasAtrzDocId={mbrasAtrzDocId}
                                    setAtrzSttsCd={setAtrzSttsCd}
                                    setCallTime={setCallTime}
                                />
                            </div>
                        </div>
                    )}

                    <div>
                        <div className="h30 dpFlx aiE pb5 bdBox">
                            <span className="fm-b fs13 ls06 fc111111">기타 첨부파일</span>
                            <span className="fm-c fs11 fc007bff ml4">(필수 아님)</span>
                        </div>

                        <div className="mt6">
                            <MemberFile
                                mbrasId={mbrasId}
                                mbrasAtchFileId={etcAtchFileId}
                                setMbrasAtchFileId={setEtcAtchFileId}
                                mbrFile={etcFile}
                                setMbrFile={setEtcFile}
                                mbrFileNm={etcFileNm}
                                setMbrFileNm={setEtcFileNm}
                                atrzSttsCd={atrzSttsCd}
                                mbrasAtrzDocId={mbrasAtrzDocId}
                                setAtrzSttsCd={setAtrzSttsCd}
                                setCallTime={setCallTime}
                            />
                        </div>
                    </div>
                </div>

                <div className="mt10 taC">
                    <span className="fm-c fs12 fc4A90A4">
                        ※ 임시저장은 입력 중인 내용으로 저장되며, 작성완료는 필수 항목 입력 후 가능합니다.
                    </span>
                </div>

                {/* 버튼 */}
                <div className="dpFlx jcC mt25 gap10 mb10">
                    {Util.isEmpty(mbrasAtrzDocId) && (
                        <Button
                            width={90}
                            height={40}
                            fontFamily="fm-b"
                            fontSize={16}
                            letterSpacing={-1}
                            variant="styCancelBtn"
                            borderRadius={6}
                            buttonClass="dpFlx aiC jcC"
                            buttonName="이전"
                            onClickFunc={() => setModalStep("CHANGE_TYPE")}
                        />
                    )}

                    <Button
                        width={90}
                        height={40}
                        fontFamily="fm-b"
                        fontSize={16}
                        letterSpacing={-1}
                        variant="styCancelBtn"
                        borderRadius={6}
                        buttonClass="dpFlx aiC jcC"
                        buttonName="닫기"
                        onClickFunc={() => setModalOpen(false)}
                    />

                    {Util.isNotEmpty(mbrasAtrzDocId) && (
                        <Button
                            width={90}
                            height={40}
                            fontFamily="fm-b"
                            fontSize={16}
                            letterSpacing={-1}
                            variant="styDeleteBtn"
                            borderRadius={6}
                            buttonClass="dpFlx aiC jcC"
                            buttonName="삭제"
                            onClickFunc={handleDelete}
                        />
                    )}

                    {atrzSttsCd === "01" && (
                        <Button
                            width={110}
                            height={40}
                            fontFamily="fm-b"
                            fontSize={16}
                            letterSpacing={-1}
                            variant="styTempBtn"
                            borderRadius={6}
                            buttonClass="dpFlx aiC jcC"
                            buttonName="임시저장"
                            onClickFunc={() => handleSave("01")}
                        />
                    )}

                    <Button
                        width={110}
                        height={40}
                        fontFamily="fm-b"
                        fontSize={16}
                        letterSpacing={-1}
                        variant="styCompleteBtn"
                        borderRadius={6}
                        buttonClass="dpFlx aiC jcC"
                        buttonName="작성완료"
                        onClickFunc={() => handleSave("02")}
                    />
                </div>
            </div>
        </div>
    );
};

export default MbrasLeaveApply;